
<div class="dn-dialog-main-bg">
  <div class ="dn-dialog-back-bg dn-dialog-container"></div>

  <mat-icon *ngIf="showCloseButton" (click)="close()">clear</mat-icon>
  <div class="container-style">
        <span class="title" [ngStyle]="{'top' : titleTop, 'left' : titleLeft}">
            {{title}}
        </span>
    <ng-content class="dn-lazy-load-target" />
  </div>


</div>


